import { CustomerAdoptionMetrics } from '@dill/dill-shared';

interface AdoptionMetricsCardsProps {
  adoptionMetrics?: CustomerAdoptionMetrics | null;
}

function AdoptionMetricsCards({ adoptionMetrics }: AdoptionMetricsCardsProps) {
  const metrics = [
    {
      label: 'Customer Adoption',
      value: adoptionMetrics?.customerAdoptionPercentage ?? 0,
      description: `${adoptionMetrics?.customersOnDill ?? 0} of ${
        adoptionMetrics?.totalCustomers ?? 0
      } customers`,
      color: 'blue',
    },
    {
      label: 'Payment Adoption',
      value: adoptionMetrics?.paymentAdoptionPercentage ?? 0,
      description: `${adoptionMetrics?.customersPayingThroughDill ?? 0} paying through portal`,
      color: 'green',
    },
    {
      label: 'Volume Adoption',
      value: adoptionMetrics?.volumeAdoptionPercentage ?? 0,
      description: `$${(adoptionMetrics?.volumePaidThroughPortal ?? 0).toLocaleString()} of $${(
        adoptionMetrics?.totalVolume ?? 0
      ).toLocaleString()}`,
      color: 'purple',
    },
  ];

  const colorClasses: Record<string, { bg: string; text: string; progress: string }> = {
    blue: { bg: 'bg-blue-50', text: 'text-blue-600', progress: 'bg-blue-500' },
    green: { bg: 'bg-green-50', text: 'text-green-600', progress: 'bg-green-500' },
    purple: { bg: 'bg-purple-50', text: 'text-purple-600', progress: 'bg-purple-500' },
  };

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Adoption Metrics</h3>
      <div className="space-y-4">
        {metrics.map((metric, index) => {
          const colors = colorClasses[metric.color];
          return (
            <div key={index} className="space-y-2">
              <div className="flex items-center justify-between">
                <span className="text-sm font-medium text-gray-700">{metric.label}</span>
                <span className={`text-lg font-bold ${colors.text}`}>
                  {metric.value.toFixed(1)}%
                </span>
              </div>
              <div className="w-full bg-gray-100 rounded-full h-2">
                <div
                  className={`${colors.progress} h-2 rounded-full transition-all duration-500`}
                  style={{ width: `${Math.min(metric.value, 100)}%` }}
                />
              </div>
              <p className="text-xs text-gray-500">{metric.description}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default AdoptionMetricsCards;
